import { PageListScreenSkeleton } from '@/shared/ui/Skeleton'

const PARTNER_THUMB_CLASS = 'aspect-[4/3] h-20 shrink-0 self-start'

export const PartnersListSkeleton = () => (
  <PageListScreenSkeleton
    showCarousel
    carouselSlides={1}
    itemCount={5}
    thumbClassName={PARTNER_THUMB_CLASS}
    aria-label="Carregando parceiros"
  />
)
